import { render, staticRenderFns } from "./emptyLogistics.vue?vue&type=template&id=d58d91d8&scoped=true"
var script = {}
import style0 from "./emptyLogistics.vue?vue&type=style&index=0&id=d58d91d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58d91d8",
  null
  
)

export default component.exports